import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

function TrackDot({ status, color, label }) {
  const baseClasses = "w-3 h-3 rounded-full border-2 cursor-pointer transition-all";

  const colorMap = {
    blue: {
      not_started: 'border-blue-400 bg-transparent',
      in_progress: 'border-blue-400 bg-blue-400/50',
      completed: 'border-blue-400 bg-blue-400'
    },
    green: {
      not_started: 'border-emerald-400 bg-transparent',
      in_progress: 'border-emerald-400 bg-emerald-400/50',
      completed: 'border-emerald-400 bg-emerald-400'
    },
    amber: {
      not_started: 'border-amber-400 bg-transparent',
      in_progress: 'border-amber-400 bg-amber-400/50',
      completed: 'border-amber-400 bg-amber-400'
    }
  };

  const statusLabel = {
    not_started: 'Not Started',
    in_progress: 'In Progress',
    completed: 'Completed'
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`${baseClasses} ${colorMap[color]?.[status] || colorMap[color]?.not_started}`} />
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          <p>{label}: {statusLabel[status] || 'Not Started'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>);

}

export default function RockTrackIndicator({ issue, onClick }) {
  const t1 = issue.rock_track1_status || 'not_started';
  const t2 = issue.rock_track2_status || 'not_started';
  const t3 = issue.rock_track3_status || 'not_started';

  return (
    <div className="bg-slate-200 px-2 py-1 rounded-md flex items-center gap-1.5 border border-slate-700/50 cursor-pointer hover:bg-slate-400 transition-colors"

    onClick={onClick}
    title="Click to manage Rock 3-Track Resolution">

      <span className="text-slate-700 mr-1">TRACKS</span>
      <TrackDot status={t1} color="blue" label="T1: Policy" />
      <TrackDot status={t2} color="green" label="T2: Capability" />
      <TrackDot status={t3} color="amber" label="T3: Operational" />
    </div>);

}